module.exports = __webpack_public_path__ + "img/CorrugatedBox2.9a83bfd3.jpg";